<div class="mx-5 my-5">
  <!-- <app-card-header [cardheaderTitle]="{{'card-header-title'|translate}}"></app-card-header> -->
  <div style="margin-top: 20px">
    <mat-card style="width: fit-content;" appMaterialElevation [raisedElevation]="raisedElevation"
      [defaultElevation]="defaultElevation">
      <mat-card-header style="margin-top: -20px">
        <!-- <img mat-card-avatar src="https://i.pinimg.com/originals/98/d3/a2/98d3a283f98cded8e639957e935bd373.png" /> -->
        <mat-card-title><span class="view-title">{{"wellcome-header-title"| translate}}</span>
        </mat-card-title>
        <mat-card-subtitle style="margin-top: 10px" class="view-subtitle">{{"wellcome-header-description" |translate}}
        </mat-card-subtitle>
      </mat-card-header>
    </mat-card>
  </div>
</div>
<div class="mx-3">
  <app-dummy-text></app-dummy-text>
</div>
